import { Step } from "react-joyride";

const createAddressPageTourSteps: Step[] = [
  {
    target: ".tour-address-line1",
    content:
      "Begin typing your address here. Select the address as it appears, or continue typing to complete your address.",
    buttons: ["close"],
    overlayClickAction: false,
    dismissKeyAction: false,
  },
  {
    target: ".tour-address-save",
    content: "Click here to save your address.",
  },
];

export default createAddressPageTourSteps;
